
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("i1a7g", function(module, exports) {
$parcel$export(module.exports, "NewPermissionErrorView", () => $f1aac1daa983c6b7$export$9fb0566f23a6bae8);
$parcel$export(module.exports, "default", () => $f1aac1daa983c6b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cdVOR = parcelRequire("cdVOR");

var $7F2no = parcelRequire("7F2no");

var $lRq8t = parcelRequire("lRq8t");

var $bkcPe = parcelRequire("bkcPe");

var $aTJmy = parcelRequire("aTJmy");

var $83DiZ = parcelRequire("83DiZ");

var $8q7lT = parcelRequire("8q7lT");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $bILK0 = parcelRequire("bILK0");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $9TSGc = parcelRequire("9TSGc");

var $d6N1A = parcelRequire("d6N1A");

var $h5LpJ = parcelRequire("h5LpJ");

const $f1aac1daa983c6b7$export$9fb0566f23a6bae8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9TSGc.useAnalyticsEvents)();
    const accountId = (0, $8q7lT.useAccountId)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const boardId = (0, $bmoS1.useBoardId)();
    const [isSubmitting, setIsSubmitting] = (0, $eJOHy.useState)(false);
    const [isRequested, setIsRequested] = (0, $eJOHy.useState)(false);
    const REQUEST_URL = '/rest/internal/latest/project-access/access-requested';
    const handleRequestAccessClick = (0, $eJOHy.useCallback)(async ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'requestProjectAccess');
        if (!accountId || !issueKey) return;
        setIsSubmitting(true);
        await (0, $d6N1A.requestAccess)({
            accountId: accountId,
            projectKey: projectKey,
            issueKey: issueKey,
            boardId: boardId
        }, REQUEST_URL);
        // Always show success flag, regardless of server response details
        showFlag({
            title: (0, $h5LpJ.messages).requestAccessSuccessTitle,
            type: 'success',
            isAutoDismiss: true,
            messageType: 'transactional',
            messageId: 'issue-view-errors.ui.new-permission-error-view.show-flag.success.flag.success.request-access-success',
            actions: [
                {
                    content: (0, $h5LpJ.messages).requestAccessSuccessAction,
                    onClick: ()=>{
                        push('/jira/your-work');
                    }
                }
            ]
        });
        setIsRequested(true);
        setIsSubmitting(false);
    }, [
        accountId,
        issueKey,
        projectKey,
        boardId,
        showFlag,
        push,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: (0, $79882cd9baba9c20$export$48e1d3fa57b0a2d5),
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: {
            requestAccessButtonShown: !!accountId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7F2no.default), {
        testId: "issue-view-errors.ui.new-permission-error-view.permission-error-view",
        header: formatMessage((0, $h5LpJ.messages).permissionErrorHeader),
        description: formatMessage((0, $h5LpJ.messages).permissionErrorDescription),
        renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $bkcPe.default)),
        primaryAction: accountId && !isRequested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cdVOR.default), {
            appearance: "primary",
            onClick: handleRequestAccessClick,
            isLoading: isSubmitting,
            interactionName: "jira-issue-view-errors.ui.new-permission-error-view.request-access-button"
        }, formatMessage((0, $h5LpJ.messages).requestAccessButton)) : null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
var $f1aac1daa983c6b7$export$2e2bcd8739ae039 = $f1aac1daa983c6b7$export$9fb0566f23a6bae8;

});
parcelRegister("bkcPe", function(module, exports) {
$parcel$export(module.exports, "default", () => $455299d30559cf08$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $15hJJ = parcelRequire("15hJJ");

var $a9b1o = parcelRequire("a9b1o");
const $455299d30559cf08$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($a9b1o)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($15hJJ))
});
var $455299d30559cf08$export$2e2bcd8739ae039 = $455299d30559cf08$var$Illustration;
// for advanced use only
const $455299d30559cf08$export$a179c88182cb9d56 = [
    0,
    0,
    163,
    218
];

});
parcelRegister("15hJJ", function(module, exports) {
module.exports = new URL("padlock-key-darkmode.78fd8599.svg", import.meta.url).toString();

});

parcelRegister("a9b1o", function(module, exports) {
module.exports = new URL("padlock-key.3d73e47c.svg", import.meta.url).toString();

});


parcelRegister("aTJmy", function(module, exports) {
$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $484fdcae7d1a2fee$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3xT3U = parcelRequire("3xT3U");
function $484fdcae7d1a2fee$export$ebf64b9217c1b2a3(JiraIllustration = (0, $3xT3U.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $awdRS.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $awdRS.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $hcewu.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("3xT3U", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gX3Gq")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jzJZf")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $jzJZf = parcelRequire("jzJZf");

var $gX3Gq = parcelRequire("gX3Gq");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gX3Gq)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jzJZf))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("jzJZf", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("gX3Gq", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("d6N1A", function(module, exports) {
$parcel$export(module.exports, "requestAccess", () => $01a1630cb3e7ecaf$export$cd9e5995821603e1);
const $01a1630cb3e7ecaf$export$bfd768ea9efe9ac4 = '/rest/internal/latest/project-access/access-requested';
const $01a1630cb3e7ecaf$export$cd9e5995821603e1 = async (payload, requestUrl)=>{
    const endpoint = requestUrl || $01a1630cb3e7ecaf$export$bfd768ea9efe9ac4;
    // we return nothing on purpose to be vague, not disclose if the project exists or not,
    // so we use fetch instead of performPutRequest as performPutRequest will return null for empty response
    return fetch(endpoint, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("h5LpJ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $be5915504ee5d4e8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $be5915504ee5d4e8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.new-permission-error-view.permission-error-header",
        "defaultMessage": "We can't show this project."
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.new-permission-error-view.permission-error-description",
        "defaultMessage": "You don't have permission to view it, or it doesn't exist. Contact your admin to request access."
    },
    requestAccessButton: {
        "id": "issue-view-errors.new-permission-error-view.request-access-button",
        "defaultMessage": "Request access"
    },
    requestAccessSuccessTitle: {
        "id": "issue-view-errors.new-permission-error-view.request-access-success-title",
        "defaultMessage": "Sent access request to admin"
    },
    requestAccessSuccessAction: {
        "id": "issue-view-errors.new-permission-error-view.request-access-success-action",
        "defaultMessage": "View your work"
    }
});

});

const $79882cd9baba9c20$export$48e1d3fa57b0a2d5 = 'workItemPermissionError';



$parcel$global.rlb("bMjU6")
//# sourceMappingURL=new-permission-error-view.2c11bc48.js.map
